import { Box, Theme, Typography, styled, useMediaQuery } from "@mui/material";
import truncate from "lodash/truncate";
import { CloseButton, SecurityImage } from "@rentablo/components";
import ExportIcon from "@icons/myicons/export.svg?react";

const StickyHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  marginTop: theme.spacing(-4),
  position: "sticky",
  top: theme.spacing(-4),
  zIndex: 1,
  backgroundColor: theme.palette.background.paper,
}));

interface Props {
  name: string;
  image?: string | null;
  href?: string;
  onRedirectClick?: () => void;
  onClose: () => void;
}

export const StickyModalHeader = ({
  name,
  image,
  href,
  onRedirectClick,
  onClose,
}: Props) => {
  const isSM = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const modalPadding = isSM ? 4 : 5;

  const showRedirect = Boolean(href || onRedirectClick);

  return (
    <StickyHeader mx={-modalPadding} px={modalPadding}>
      <Box display="flex" alignItems="center" gap={4} minWidth={0}>
        <SecurityImage src={image} width={32} height={32} alt={name} />
        <Box minWidth={0} display="flex" alignItems="center" gap={2}>
          <Typography variant="h5" noWrap>
            {truncate(name, { length: 50, separator: " " })}
          </Typography>
          {showRedirect && (
            <Box
              component={href ? "a" : "button"}
              href={href}
              onClick={onRedirectClick}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "text.primary",
                p: 0,
                "&:hover": { color: "primary.main" },
              }}
              aria-label="open-full-page"
            >
              <ExportIcon width={24} height={24} />
            </Box>
          )}
        </Box>
      </Box>
      <CloseButton onClose={onClose} />
    </StickyHeader>
  );
};
